export { usePreventScroll } from '@react-aria/overlays';
//# sourceMappingURL=usePreventScroll.web.js.map